module.exports = "/static/hooks/build/assets/open-iconic-47151e87c5a8666791a91007de4962da.eot";